
/**
 * 
 * @param {*} id 
 */
export const reviewDriver = (id) => {
    return {
        type: 'REVIEW_DRIVER',
        payload: 'driver'
    }
}

/**
 * 
 * @param {*} id 
 */
export const approveDriver = (id) => {

}

/**
 * 
 * @param {*} id 
 */
export const removeDriver = (updatedData) => {
    console.log(updatedData);
    return {
        type: 'REMOVE_DRIVER',
        payload: updatedData
    }
}

/**
 * 
 * @param {*} id 
 */
export const reviewVehicle = (id) => {
    
}

/**
 * 
 * @param {*} id 
 */
export const approveVehicle = (id) => {
    
}

/**
 * 
 * @param {*} id 
 */
export const removeVehicle = (updatedData) => {
    console.log(updatedData);
    return {
        type: 'REMOVE_VEHICLE',
        payload: updatedData
    }
}

export const populateCustomerActivity = (data) => {
    //alert('data');
    return {
        type: 'POPULATE_CUSTOMER_ACTIVITY',
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/Review/actions.js